// extracted by mini-css-extract-plugin
export var aircallIframe = "_d2-3";
export var fabContainer = "_d2-5";
export var fabRinging = "_d2-6";
export var loadingOverlay = "_d2-4";
export var pulse = "_d2-7";
export var widgetContent = "_d2-2";
export var widgetPanel = "_d2-0";
export var widgetPanelExpanded = "_d2-1";